import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitCategories } from "./useGetBenefitCategories";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  attachmentName: string;
  payload: Attachment;
};
const updateAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  attachmentName,
  payload,
}: Params) => {
  const response = await api.patch(
    `/client/attachment/${countryCode}/${clientInternalNumberGOS}/${attachmentName}`,
    payload
  );
  return response.data as Attachment;
};
export function useUpdateClientAttachment(refetch = true) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitCategories = useInvalidateBenefitCategories();

  return useMutation(updateAttachment, {
    mutationKey: MUTATION_KEYS.updateClientAttachment,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitCategories();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
